import { useState, useEffect } from 'react'
import { subscribeProgress, unsubscribeProgress, cancelTask, submitTask, deleteTask } from 'utils/uploadQueue'

export const useUploadQueue = () => {
    const [progress, setProgressState] = useState({})

    useEffect(() => {
        const progressSubcribeHandler = subscribeProgress(data => {
            setProgressState(data)
        })
        return () => unsubscribeProgress(progressSubcribeHandler)
    }, [setProgressState])

    return { progress, setProgressState, cancelTask, submitTask, deleteTask }
}

export default useUploadQueue
